import React, { useState } from 'react';

import { CustomizedRoundIcon } from 'components/common/CustomizedRoundIcon/CustomizedRoundIcon';
import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import { ShareInsightModal } from 'components/common/ShareInsightModal/ShareInsightModal';

interface IShareInsightButtonProps {
    title: string;
    link: string;
    size?: string;
    customTriggerElement?: React.ReactElement<{ onClick?: React.MouseEventHandler }>;
}

export const ShareInsightButton = ({ title, link, size = '4rem', customTriggerElement }: IShareInsightButtonProps) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const handleClick = () => {
        setIsModalOpen(true);
    };

    return null;
    return (
        <>
            <CustomizedTooltip
                tooltipContent={'Share'}
                triggerElement={
                    customTriggerElement ? (
                        React.cloneElement(customTriggerElement, {
                            onClick: handleClick,
                        })
                    ) : (
                        <CustomizedRoundIcon onClick={handleClick} size={size}>
                            <MuiIcon icon={'share'} fontSize={'22px'} />
                        </CustomizedRoundIcon>
                    )
                }
            />
            {isModalOpen && (
                <ShareInsightModal
                    title={title}
                    link={link}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                />
            )}
        </>
    );
};
